// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const StopwatchIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="StopwatchIcon" ref={forwardedRef} {...props}>
      <path d="M9.25 9v4h1.5V9z" />
      <path d="M3.496 11.5a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0m6.5 5a5 5 0 1 1 0-10 5 5 0 0 1 0 10" />
      <path d="M7.496 2h5v1.5h-1.75V6h-1.5V3.5h-1.75z" />
      <path d="M14.768 4.482 13 6.25l1.768 1.768 1.767-1.768z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const StopwatchIcon = /* @__PURE__ */ Object.assign(
  StopwatchIconComponent,
  { displayName: 'StopwatchIcon' },
);
